/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceDto
 */
export interface BalanceDto {
    /**
     * 
     * @type {number}
     * @memberof BalanceDto
     */
    cashBalance: number;
    /**
     * 
     * @type {number}
     * @memberof BalanceDto
     */
    pointsBalance: number;
}

/**
 * Check if a given object implements the BalanceDto interface.
 */
export function instanceOfBalanceDto(value: object): value is BalanceDto {
    if (!('cashBalance' in value) || value['cashBalance'] === undefined) return false;
    if (!('pointsBalance' in value) || value['pointsBalance'] === undefined) return false;
    return true;
}

export function BalanceDtoFromJSON(json: any): BalanceDto {
    return BalanceDtoFromJSONTyped(json, false);
}

export function BalanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cashBalance': json['cashBalance'],
        'pointsBalance': json['pointsBalance'],
    };
}

export function BalanceDtoToJSON(value?: BalanceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cashBalance': value['cashBalance'],
        'pointsBalance': value['pointsBalance'],
    };
}

